import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


export interface DialogData {
  confirm: true;
}
@Component({
    selector: 'core-save-confirm-dialog',
    templateUrl: './save-confirm-dialog.component.html',
    styleUrls: ['./save-confirm-dialog.component.scss'],
    standalone: false
})
export class SaveConfirmDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<SaveConfirmDialogComponent>
  ) { }

  ngOnInit(): void {
  }

}
